export default __webpack_public_path__ + "static/media/openbook.c1aa51a0.png";